import { FC, memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { cargoSizeDataSelector } from 'api/cargoSize'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import { formatPrice } from 'helpers/common'
import Box3Icon from 'remixicon/icons/Others/box-3-line.svg?react'
import InformationIcon from 'remixicon/icons/System/information-line.svg?react'
import ShieldIcon from 'remixicon/icons/System/shield-line.svg?react'
import { OrderYarcheCreateCargo } from 'schema'

import { formatCargoSize, formatCargoWeightGramToKilogram } from '../helpers/formatCargo'

interface OrderYarcheCreateSummaryCargoProps {
  cargo?: OrderYarcheCreateCargo
  isLoading?: boolean
}

const OrderYarcheCreateSummaryCargo: FC<OrderYarcheCreateSummaryCargoProps> = (props) => {
  const { cargo, isLoading } = props
  const cargoSizes = useSelector(cargoSizeDataSelector)

  const size = useMemo(() => {
    const cargoSizeItem = cargoSizes?.find((cargoSize) => cargoSize.id === cargo?.sizeId)

    if (!cargoSizeItem) {
      return { name: '—', description: '—' }
    }

    return {
      name: cargoSizeItem.name,
      description: `до ${formatCargoWeightGramToKilogram(cargoSizeItem.weight)} / ${formatCargoSize(cargoSizeItem.length, cargoSizeItem.width, cargoSizeItem.height, false)}`
    }
  }, [cargo?.sizeId, cargoSizes])

  return isLoading ? (
    <>
      <div className="mb-2">
        <PlaceholderCell height={20} />
      </div>
      <div className="mb-2">
        <PlaceholderCell height={20} />
      </div>
      <div className="mb-2">
        <PlaceholderCell height={20} />
      </div>
    </>
  ) : (
    <>
      <div className="mb-2 grid grid-cols-[20px_60px_auto] gap-2 text-body-md">
        <Box3Icon className="text-on-surface-variant" containerSize="sm" size="xs" />
        <div>{size.name}</div>
        <div className="truncate text-right">{size.description}</div>
      </div>
      <div className="mb-2 grid grid-cols-[20px_120px_auto] gap-2 text-body-md">
        <InformationIcon className="text-on-surface-variant" containerSize="sm" size="xs" />
        <div>Описание груза</div>
        <div className="truncate text-right">{cargo?.about || '—'}</div>
      </div>
      <div className="mb-2 grid grid-cols-[20px_156px_auto] gap-2 text-body-md">
        <ShieldIcon className="text-on-surface-variant" containerSize="sm" size="xs" />
        <div>Объявленная ценность</div>
        <div className="truncate text-right">{cargo?.price ? `${formatPrice(cargo.price)} ₽` : '—'}</div>
      </div>
    </>
  )
}

export default memo(OrderYarcheCreateSummaryCargo)
